import * as React from 'react';
import { ICardColorTagsProps } from './types';
import './_CardColorTags.scss';
import { CARD_ACTIONS_PORTAL, CARD_CLASS, CARD_CONTROL_CLASS } from '../../..';
import { Button, ButtonDropdown } from 'kui';
import { ColorTags } from '../../../../../base/components/ColorTags/ColorTags';
import { EPaletteVariant } from '../../../../../base/components/ColorPalette/types';
import { ActionModal } from '../../../../../base/components/ActionModal/ActionModal';
import {
    BOARD_SECTION_COLORS_MODAL_CANCEL,
    BOARD_SECTION_COLORS_MODAL_REMOVE
} from '../../../../../aside_panel/boardDetails/details/Colors/components/BoardColors/constants';
import { getMessages, root } from '../../../../../../../store/constants';
import { CLASS_ACTION_MODAL } from '../../../../../base/components/ActionModal/constants';
import {
    ColorTagsDropdownHOC
} from '../../../../../base/components/ColorTagsDropdown/hocs/ColorTagsDropdownHOC/ColorTagsDropdownHOC';
import {
    CARD_ADD_COLOR_TAGS
} from '../../../../../aside_panel/cardDetails/ColorTags/components/CardColorTags/constants';
import { TOP_BAR_CLASS } from '../../../../topBar/constants';
import {
    EssentialUpgradeButtonHOC
} from '../../../../../base/components/EssentialUpgradeButton/hocs/EssentialUpgradeButtonHOC/EssentialUpgradeButtonHOC';
import { CLASS_COLOR_TAGS_DROPDOWN } from '../../../../../base/components/ColorTagsDropdown/constants';
import { GOOGLE_SPACING } from '../../../../../../../const';
import { v4 as uuidv4 } from 'uuid';
import { CLASS_COLOR_PALETTE } from '../../../../../base/components/ColorPalette/constants';
import { COLOR_TAGS_SEARCH_SCROLL_TIMEOUT, COLOR_TAGS_SEARCH_SCROLL_UP_HINT } from './constants';
import { EHintKey, HintHOC } from '../../../../../hints';
import { CLASS_CARD_DETAILS } from '../../../../../aside_panel/cardDetails';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';

const analyzeRender = root.Settings.development ? new AnalyzeRender(`CardColorTags`) : null;

export function CardColorTags({
    aloudCount,
    colorTags,
    boardId,
    cardId,
    isHintShown,
    isNeedToScroll,
    isOpened: _isOpened,
    isReadonly,
    listId,
    showColorTagsCount,
    onClose,
    onHideHint,
    onToggle,
    onOpenSettings,
    onOpen,
    setOpened: _setOpened,
}: ICardColorTagsProps) {
    if (analyzeRender) analyzeRender.call(`${cardId}`);

    const className = CARD_CLASS + '-color-tags';
    const classDropdown = className + '__dropdown';
    const classHint = className + '__hint';
    const [classUnique] = React.useState(className + uuidv4());
    const [classDropdownUnique] = React.useState(classDropdown + uuidv4());
    const portalId = `${CARD_ACTIONS_PORTAL}-${listId}`;

    const [isOpened, setOpened] = React.useState(null);
    const [removingId, setRemovingId] = React.useState(null);
    const [count, setCount] = React.useState(showColorTagsCount);
    const [isFocus, setFocus] = React.useState(null);
    const [isEditing, setEditing] = React.useState(null);
    const [isReset, setReset] = React.useState(null);
    const [isShowHint, setShowHint] = React.useState(null);
    const [isNoScroll, setNoScroll] = React.useState(!isNeedToScroll);

    React.useEffect(() => {
        if (!_isOpened) return;
        setOpened(_isOpened);
    }, [_isOpened]);

    React.useEffect(() => {
        if (!isOpened) return;
        const onResize = () => {
            const button = document.querySelector('.' + classUnique) as HTMLElement
            if (!button) return;

            const dropdown = document.querySelector('.' + classDropdownUnique) as HTMLElement
            if (!dropdown) return;

            if (dropdown.className.includes('kui-dropdown--direction_up')) {
                dropdown.style.height = Math.round(button.getBoundingClientRect().top) - GOOGLE_SPACING * 3 + 'px';
            } else {
                dropdown.style.height = root._innerHeight - Math.round(button.getBoundingClientRect().bottom) - GOOGLE_SPACING * 2 + 'px';
            }
        };

        onResize();

        root.addEventListener('resize', onResize);
        return () => {
            root.removeEventListener('resize', onResize);
        }
    }, [isOpened]);

    const onModalClose = () => {
        onClose();
        setRemovingId(null);
    };

    const onClick = () => {
        if (isEditing && isOpened) {
            setReset(true);
            setFocus(false);
            setTimeout(() => {
                setReset(false);
            }, 0);
        } else {
            setOpened(!isOpened);
        }
    };

    const button = colorTags.length ?
        <Button
            className={`${className}__button ${classUnique}`}
            href={isOpened ? null : ''} // чтоб был тег <a>, на <button> не работает dnd почему-то // но на <a> повторный клик не закрывает
            variant={'icon'}
        >
            <ColorTags colorTags={colorTags} size={24} onClick={onClick} />
        </Button>
        : <Button
            className={`${className}__button-add ${classUnique}`}
            variant={'add'}
        >
            {CARD_ADD_COLOR_TAGS}
        </Button>;

    return <>
        <ButtonDropdown
            opened={isOpened}
            portal
            portalId={portalId}
            disabled={isReadonly}
            className={`${className} ${CARD_CONTROL_CLASS}`}
            beforeOpen={() => {
                setCount(showColorTagsCount);
                return Promise.resolve();
            }}
            dropdownClassName={`
                ${className}__dropdown
                ${isNoScroll ? classDropdown + '--no-scroll' : ''}
                ${isFocus || isEditing ? classDropdown + '--focus' : ''}
                ${classDropdown}--${count}
                ${classDropdownUnique} ${CARD_CONTROL_CLASS}
            `}
            onClose={() => {
                setOpened(false);
                setEditing(false);
                setNoScroll(true);
                setFocus(false);
                _setOpened(false);
                const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
                if (topBar) {
                    topBar.style.zIndex = '120'; // $z-fold * 1.2
                }
            }}
            onOpen={() => {
                const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
                if (topBar) {
                    topBar.style.zIndex = 'unset';
                }
                onOpen();
                setOpened(true);
                _setOpened(true);
                const hideSearch = () => {
                    const dd = document.querySelector(`.${className}__dropdown .kui-dropdown__item`) as HTMLElement;
                    const search = document.querySelector(`.${CLASS_COLOR_TAGS_DROPDOWN}__input`) as HTMLElement;
                    if (dd && search) { // прячим поиск
                        dd.scrollTop = search.offsetHeight + GOOGLE_SPACING * 2.75; // + margin and padding
                    }
                    setTimeout(() => {
                        setNoScroll(false);
                        if (isHintShown) return;
                        setShowHint(true);
                        const dd = document.querySelector(`.${className}__dropdown .kui-dropdown__item`) as HTMLElement;
                        if (dd) {
                            const onScroll = () => {
                                const isScrolledUp = dd.scrollTop < 20;
                                if (isScrolledUp) {
                                    onHideHint();
                                    dd.removeEventListener('scroll', onScroll);
                                }
                            };
                            dd.addEventListener('scroll', onScroll);
                        }
                    }, 500);
                };
                if (isNeedToScroll) {
                    setTimeout(hideSearch, COLOR_TAGS_SEARCH_SCROLL_TIMEOUT);
                } else {
                    setTimeout(hideSearch, 50);
                }
            }}
            notBlurClasses={[CLASS_ACTION_MODAL, CLASS_COLOR_PALETTE + '-color-row__picker-dropdown']}
            onClick={e => { // с шифтом клик открывает ссылку в новой табе
                if (e.shiftKey) e.preventDefault();
            }}
        >
            {button}
            <>
                <HintHOC
                    className={`${classHint} ${CARD_CONTROL_CLASS}`}
                    key={EHintKey.KANBAN_COLOR_TAGS_SCROLL_UP}
                    hintKey={EHintKey.KANBAN_COLOR_TAGS_SCROLL_UP}
                    show={isShowHint}
                    isHideOnHintClick
                    isHidable={false}
                    direction={'up'}
                    arrow={'down'}
                    value={COLOR_TAGS_SEARCH_SCROLL_UP_HINT}
                    selector={`.${CLASS_CARD_DETAILS}__color-tags-item`}
                    onHide={() => {
                        const dd = document.querySelector(`.${className}__dropdown .kui-dropdown__item`) as HTMLElement;
                        dd.scrollTop = 0;
                    }}
                />
                <ColorTagsDropdownHOC
                    boardId={boardId}
                    colorTags={colorTags}
                    setInputFocus={setFocus}
                    onClose={() => {
                        setOpened(false);
                        setEditing(false);
                        _setOpened(false);
                    }}
                    onChange={(id, clickSource, source) => onToggle(id, source)}
                    paletteVariant={EPaletteVariant.TAG_COLOR_KANBAN_CARD}
                    onOpenSettings={onOpenSettings}
                    setRemovingId={setRemovingId}
                    onSetEditing={setEditing}
                    isSmall
                    isReset={isReset}
                />
            </>
            <ActionModal
                isShow={!!removingId}
                actions={[
                    {
                        variant: 'primary',
                        onClick: onModalClose,
                        children: BOARD_SECTION_COLORS_MODAL_CANCEL
                    },
                    {
                        variant: 'secondary',
                        onClick: () => {
                            onModalClose();
                            return onToggle(removingId);
                        },
                        children: BOARD_SECTION_COLORS_MODAL_REMOVE
                    },
                ]}
                footer={<EssentialUpgradeButtonHOC onClick={onModalClose} />}
                text={getMessages().getText('board_settings.colors.modal.text', null, aloudCount)}
                title={getMessages().getText('board_settings.colors.modal.title', null, colorTags.find(color => color.id === removingId)?.name)}
                onClose={onModalClose}
            />
        </ButtonDropdown>
    </>;
}
